function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Formik } from 'formik';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import FormSection from '../../components/containers/FormSection';
import Control from '../../components/form/Control';
import { resetUserForm, updateUserProfile } from '../../redux/actions';
import { isDefault, isLoading, isSuccess } from '../../redux/stateTools';
import text from '../../text';
import { checkFieldsAreDiff } from '../../utilities/object';
import { userFormSchema } from '../../validation';
import AutoSave from '../dashboard/components/AutoSave';
var UserForm = function() {
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return state.profileReducer;
    }), userProfile = _useSelector.userProfile, updateUserProfileState = _useSelector.updateUserProfileState;
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values, actions) {
            var diffFields;
            return _ts_generator(this, function(_state) {
                diffFields = checkFieldsAreDiff(userProfile, values);
                if (Object.entries(diffFields).some(Boolean)) {
                    dispatch(updateUserProfile(values));
                    actions.resetForm({
                        touched: diffFields,
                        values: values
                    });
                }
                return [
                    2
                ];
            });
        });
        return function handleSubmit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    return !isEmpty(userProfile) && /*#__PURE__*/ React.createElement(FormSection, {
        title: text('profile')
    }, /*#__PURE__*/ React.createElement(Formik, {
        validationSchema: userFormSchema,
        validateOnBlur: true,
        initialValues: userProfile,
        onSubmit: handleSubmit
    }, function(param) {
        var user = param.values, handleBlur = param.handleBlur, handleChange = param.handleChange, setTouched = param.setTouched, touched = param.touched, errors = param.errors, isValid = param.isValid;
        var handleChangeWithReset = function(newValues) {
            if (!isDefault(updateUserProfileState)) {
                dispatch(resetUserForm());
            }
            handleChange(newValues);
        };
        var isFormTouched = touched && Object.values(touched).some(Boolean);
        var _user_full_name, _user_email, _user_phone, _user_profession;
        return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
            md: "6"
        }, /*#__PURE__*/ React.createElement(Control, {
            required: true,
            isSuccessful: touched.full_name && isSuccess(updateUserProfileState),
            isFailed: isFormTouched && errors.full_name,
            as: "input",
            type: "text",
            name: "full_name",
            value: (_user_full_name = user.full_name) !== null && _user_full_name !== void 0 ? _user_full_name : '',
            onInput: function() {
                return setTouched({
                    full_name: true
                });
            },
            onChange: handleChangeWithReset,
            onBlur: handleBlur,
            label: text('fullName'),
            validationError: errors.full_name
        })), /*#__PURE__*/ React.createElement(Col, {
            md: "6"
        }, /*#__PURE__*/ React.createElement(Control, {
            as: "input",
            type: "email",
            name: "email",
            value: (_user_email = user.email) !== null && _user_email !== void 0 ? _user_email : '',
            onBlur: handleBlur,
            label: text('email'),
            disabled: true
        }))), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
            md: "6"
        }, /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.phone && isSuccess(updateUserProfileState),
            isFailed: isFormTouched && errors.phone,
            as: "input",
            type: "tel",
            name: "phone",
            value: (_user_phone = user.phone) !== null && _user_phone !== void 0 ? _user_phone : '',
            onInput: function() {
                return setTouched({
                    phone: true
                });
            },
            onChange: handleChangeWithReset,
            onBlur: handleBlur,
            label: text('phone'),
            validationError: errors.phone
        })), /*#__PURE__*/ React.createElement(Col, {
            md: "6"
        }, /*#__PURE__*/ React.createElement(Control, {
            isSuccessful: touched.profession && isSuccess(updateUserProfileState),
            isFailed: isFormTouched && errors.profession,
            as: "input",
            type: "text",
            name: "profession",
            onBlur: handleBlur,
            label: text('occupation'),
            value: (_user_profession = user.profession) !== null && _user_profession !== void 0 ? _user_profession : '',
            onChange: handleChangeWithReset
        }))), /*#__PURE__*/ React.createElement(AutoSave, {
            isValidForm: isValid,
            isSubmitting: isLoading(updateUserProfileState),
            onSubmit: handleSubmit
        }));
    }));
};
export default UserForm;
